if (!customElements.get('slide-show-page')) {
  class slideShowPage extends HTMLElement {
    constructor() {
      super();
      this.slides = this.querySelectorAll('.slider__item');
      if (this.slides.length < 2) return;
      window.initLazyScript(this, this.init.bind(this));
    }

    disconnectedCallback() {
      window.removeEventListener('on:breakpoint-change', this.breakpointChangeHandler);
      window.removeEventListener('resize', this.handleResize);
      if (this.mutationObserver) this.mutationObserver.disconnect();  // 取消观察
    }

    init() {
      this.slider = this.querySelector('.slider');
      this.grid = this.querySelector('.slider__grid');
      this.nav = this.querySelector('.slider-nav');
      this.pagination = this.querySelector('.slideshow-pagination');
      this.rtl = document.dir === 'rtl';
      // 添加以下代码，监听窗口大小变化事件
      this.mutationObserver = new MutationObserver(() => {
        if (getComputedStyle(this).display !== 'none') {
          this.removeListeners();
          this.initSlider();
          if (this.pagination) {
            this.pageBtns = this.querySelectorAll('.page-btn');
            this.paginationClickHandler = this.handlePaginationClick.bind(this);
            this.pagination.addEventListener('click', this.paginationClickHandler);
          }
          this.updatePagination(this.getCurrentIndex()); // 更新分页状态
        }
      });
  
      // 开始监听属性变化
      this.mutationObserver.observe(this, { attributes: true, attributeFilter: ['class'] });
      // 处理窗口大小变化时的重新初始化
      this.handleResize = debounce(() => {
        this.removeListeners();
        this.initSlider();
        if (this.pagination) {
          this.pageBtns = this.querySelectorAll('.page-btn');
          this.paginationClickHandler = this.handlePaginationClick.bind(this);
          this.pagination.addEventListener('click', this.paginationClickHandler);
        }
        this.updatePagination(this.getCurrentIndex()); // 更新分页状态
      }, 200);

      window.addEventListener('resize', this.handleResize);
      this.breakpointChangeHandler = this.breakpointChangeHandler
        || this.handleBreakpointChange.bind(this);
      if (this.nav) {
        this.prevBtn = this.querySelector('button[name="prev"]');
        this.nextBtn = this.querySelector('button[name="next"]');
      }
      this.initSlider();
      window.addEventListener('on:breakpoint-change', this.breakpointChangeHandler);

      // 如果有分页元素，绑定点击事件
      if (this.pagination) {
        this.pageBtns = this.querySelectorAll('.page-btn');
        this.paginationClickHandler = this.handlePaginationClick.bind(this);
        this.pagination.addEventListener('click', this.paginationClickHandler);
        this.pageBtns.forEach((btn, index) => {
          if (index === 0) {
            btn.classList.add('active');
          } else {
            btn.classList.remove('active');
          }
        });
      }
    }

    initSlider() {
      this.gridWidth = this.grid.clientWidth;
      this.slideSpan = this.getWindowOffset(this.slides[1]) - this.getWindowOffset(this.slides[0]);
      this.slideGap = this.slideSpan - this.slides[0].clientWidth;
      this.slidesPerPage = Math.round((this.gridWidth + this.slideGap) / this.slideSpan);
      this.slidesToScroll = theme.settings.sliderItemsPerNav === 'page' ? this.slidesPerPage : 1;
      this.totalPages = this.slides.length - this.slidesPerPage + 1;
      this.setCarouselState(this.totalPages > 1);
      if (this.totalPages < 2) return;

      this.sliderStart = this.getWindowOffset(this.slider);
      if (!this.sliderStart) this.sliderStart = (this.slider.clientWidth - this.gridWidth) / 2;
      this.sliderEnd = this.sliderStart + this.gridWidth;

      if (window.matchMedia('(pointer: fine)').matches) {
        this.slider.classList.add('is-grabbable');
      }
      this.sliderEnd = this.sliderStart + this.gridWidth;

      this.addListeners();
      this.setButtonStates();
      this.previousIndex = this.getCurrentIndex();
    }

    addListeners() {
      if (this.nav) {
        this.scrollHandler = debounce(this.handleScroll.bind(this));
        this.navClickHandler = this.handleNavClick.bind(this);

        this.slider.addEventListener('scroll', this.scrollHandler);
        this.nav.addEventListener('click', this.navClickHandler);
      }
      this.scrollHandler = debounce(this.handleScroll.bind(this));
      this.slider.addEventListener('scroll', this.scrollHandler);
      if (window.matchMedia('(pointer: fine)').matches) {
        this.mousedownHandler = this.handleMousedown.bind(this);
        this.mouseupHandler = this.handleMouseup.bind(this);
        this.mousemoveHandler = this.handleMousemove.bind(this);

        this.slider.addEventListener('mousedown', this.mousedownHandler);
        this.slider.addEventListener('mouseup', this.mouseupHandler);
        this.slider.addEventListener('mouseleave', this.mouseupHandler);
        this.slider.addEventListener('mousemove', this.mousemoveHandler);
      }
    }

    removeListeners() {
      if (this.nav) {
        this.slider.removeEventListener('scroll', this.scrollHandler);
        this.nav.removeEventListener('click', this.navClickHandler);
      }
      this.slider.removeEventListener('scroll', this.scrollHandler);
      if (this.pagination) {
        this.pagination.removeEventListener('click', this.paginationClickHandler);
      }
      this.slider.removeEventListener('mousedown', this.mousedownHandler);
      this.slider.removeEventListener('mouseup', this.mouseupHandler);
      this.slider.removeEventListener('mouseleave', this.mouseupHandler);
      this.slider.removeEventListener('mousemove', this.mousemoveHandler);
    }

    /**
     * 处理分页点击事件
     */
    handlePaginationClick(evt) {
      const clickedBtn = evt.target.closest('.page-btn');
      if (!clickedBtn) return;
      const targetIndex = Number(clickedBtn.dataset.index);
      this.setActiveSlide(targetIndex);
    }

    /**
     * 滚动事件
     */
    handleScroll() {
      this.currentIndex = Math.round(this.slider.scrollLeft / this.slideSpan);
      this.setButtonStates();
      // 检查是否改变幻灯片索引
      if (this.currentIndex !== this.previousIndex) {
        this.triggerSlideChangeEvent(this.currentIndex);
        this.previousIndex = this.currentIndex;
        this.setActiveSlide( this.previousIndex )
      }
    }

    /**
     * 设置当前幻灯片
     */
    setActiveSlide(slideIndex) {
      const scrollPosition = slideIndex * this.slideSpan;
      this.slider.scrollTo({ left: scrollPosition, behavior: 'smooth' });
      this.updatePagination(slideIndex);
    }

    /**
     * 更新分页状态
     */
    updatePagination(slideIndex) {
      this.pageBtns.forEach((btn, index) => {
        if (index === slideIndex) {
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      });
    }
    handleMousedown(evt) {
      this.mousedown = true;
      this.startX = evt.pageX - this.sliderStart;
      this.scrollPos = this.slider.scrollLeft;
      this.slider.classList.add('is-grabbing');
    }

    /**
     * Handles 'mouseup' events on the slider element.
     */
    handleMouseup() {
      this.mousedown = false;
      this.slider.classList.remove('is-grabbing');
    }

    /**
     * Handles 'mousemove' events on the slider element.
     * @param {object} evt - Event object.
     */
    handleMousemove(evt) {
      if (!this.mousedown) return;
      evt.preventDefault();

      const x = evt.pageX - this.sliderStart;
      this.slider.scrollLeft = this.scrollPos - (x - this.startX) * 2;
    }
    handleNavClick(evt) {
      if (!evt.target.matches('.slider-nav__btn')) return;

      if ((evt.target.name === 'next' && !this.rtl) || (evt.target.name === 'prev' && this.rtl)) {
        this.scrollPos = this.slider.scrollLeft + this.slidesToScroll * this.slideSpan;
      } else {
        this.scrollPos = this.slider.scrollLeft - this.slidesToScroll * this.slideSpan;
      }

      this.slider.scrollTo({ left: this.scrollPos, behavior: 'smooth' });
    }
    triggerSlideChangeEvent(currentIndex) {
      const slideChangeEvent = new CustomEvent('slide-change', {
        detail: { currentIndex },
      });
      this.dispatchEvent(slideChangeEvent);
    }

    handleBreakpointChange() {
      this.removeListeners();
      this.initSlider();
    }

    getWindowOffset(el) {
      return this.rtl
        ? window.innerWidth - el.getBoundingClientRect().right
        : el.getBoundingClientRect().left;
    }

    getCurrentIndex() {
      return Math.round(this.slider.scrollLeft / this.slideSpan);
    }
    getSlideVisibility(el) {
      const slideStart = this.getWindowOffset(el);
      const slideEnd = Math.floor(slideStart + this.slides[0].clientWidth);
      return slideStart >= this.sliderStart && slideEnd <= this.sliderEnd;
    }
    setCarouselState(active) {
      if (active) {
        this.removeAttribute('inactive');

        // If slider width changed when activated, reinitialise it.
        if (this.gridWidth !== this.grid.clientWidth) {
          this.handleBreakpointChange();
        }
      } else {
        this.setAttribute('inactive', '');
      }
    }
    setButtonStates() {
      if (!this.prevBtn && !this.nextBtn) {
        return;
      }

      this.prevBtn.disabled = this.getSlideVisibility(this.slides[0]) && this.slider.scrollLeft === 0;
      this.nextBtn.disabled = this.getSlideVisibility(this.slides[this.slides.length - 1]);
    }
  }

  customElements.define('slide-show-page', slideShowPage);

}